import { html, LitElement } from 'lit';
import { fileManagerBrowse, utils } from '../modules/FileManagerBrowse.js';
import { icons } from '../utils/SVGIcons.js'

export default class SWLRIFileManagerBrowseList extends LitElement {
    static get properties(){
        return {
            _fileList: {state:true},
            _toggledFiles: {state:true}
        }
    }

    constructor(){
        super();
        this._fileList = [];
        this._toggledFiles = {};
        this._totalPageNumber = 0;
        this._filterPanelOpen = false;
    }

    createRenderRoot() {
        return this;
    }

    connectedCallback(){
        super.connectedCallback();
        window.addEventListener("swlri-file-manager-browse-list-changed", this._updateFileList.bind(this))
    }

    _getHeaderCount(){
        let h = '';
        let count = fileManagerBrowse._currentTotalFiles;
        h = count + " Document"+(count == 0 || count > 1 ? 's' : '') +" found";
        
        return h;
    }

    _toggleFileInfo(e){
        e.preventDefault();
        let ind = e.currentTarget?.getAttribute("file-ind");
        if(ind) {
            this._toggledFiles[+ind] = !this._toggledFiles[+ind]
        }
        this._toggledFiles = {...this._toggledFiles};

    }


    _formatColOutput(record, type, icon = true, full = false){
        let rec = {...record};
        if(type == 'created_at'){
            let date = record.display;
            try{
                rec.display = utils.joinDate(new Date(date))
            } catch(e){
                console.log(e)
                rec.display = date;
            }
        }
        else if(type == 'note' && !full){
            if(record.display !== null && record.display.length > 100) {
                rec.display = rec.display.substr(0,100) + '...';
                
            }
        }
        return utils.formatColOutput(rec,type,icon);
    }

    _openFile(e){
        e.preventDefault();
        e.stopPropagation();
        let rootPath = '/wp-content/hy_file_manager_root';
        let fileName = e.currentTarget.getAttribute("file-name")
        let filePath = e.currentTarget.getAttribute("file-path")
        if(fileName && filePath){
            window.open(window.location.origin+rootPath+filePath+'/'+utils.parseHtml(fileName), "_blank");
        }

    }

    _toggleFilter(e){
        e.preventDefault()
        fileManagerBrowse.filterPanelOpened = true;
    }

    render(){
        return html`
            <div class ='swlri-file-manager-browse-toggle-mobile-filter'>
                <span @click=${this._toggleFilter} class='swlri-file-manager-browse-text-filter-icon'>${icons.searchIcon}</span> <h4>Filters</h4>
            </div> 
            <h4 class='swlri-file-manager-browse-results-header'>
                <span class='swlri-file-manager-browse-results-header-count'>${this._getHeaderCount()}</span>
            </h4>
            <div class="swlri-file-manager-browse-results-container">
                ${this._fileList.map((file,ind)=>{
                    return html`
                        <div class="swlri-file-manager-browse-result-card${this._toggledFiles[ind] ? ' swlri-file-manager-browse-info-expanded' : ''}">
                            <div class='swlri-file-manager-browse-ext-container'>
                                <span class="swlri-file-manager-browse-ext">${this._formatColOutput(file.ext,'ext')}</span>
                                <span class="swlri-file-manager-browse-size">${this._formatColOutput(file.file_size,'file_size')}</span>
                                <a @click=${this._toggleFileInfo} file-ind="${ind}" class='swlri-file-manager-browse-all-info'>${this._toggledFiles[ind] ? 'Hide file info' : 'Show all file info'}</a>
                            </div>
                            <div class='swlri-file-manager-browse-info-container'>
                                <div class='swlri-file-manager-browse-info-main'>
                                    <span class='swlri-file-manager-browse-info-theme'><span class='swlri-file-manager-browse-info-icon'>${icons.categoryIcon}</span><span>${this._formatColOutput(file.theme,'theme')} / ${this._formatColOutput(file.subtheme,'subtheme')}</span></span>
                                    <span class='swlri-file-manager-browse-info-theme'><span class='swlri-file-manager-browse-info-icon'>${icons.geographicIcon}</span><span>${this._formatColOutput(file.geographic,'geographic')}</span></span>
                                    <span class='swlri-file-manager-browse-info-name' @click=${this._openFile} file-path="${file.file_path.attr}" file-name="${file.file_name.attr}">${this._formatColOutput(file.file_name, 'file_name')}</span>
                                    <span class='swlri-file-manager-browse-info-note'>${this._formatColOutput(file.note, 'note')}</span>
                                </div>
                                <div class='swlri-file-manager-browse-info-footer'>
                                    <span class='swlri-file-manager-browse-footer-item'><span class='swlri-file-manager-browse-footer-icon'>${icons.userIcon}</span>${this._formatColOutput(file.user, 'user')}</span>
                                    <span class='swlri-file-manager-browse-footer-item'><span class='swlri-file-manager-browse-footer-icon'>${icons.calendarIcon}</span>${this._formatColOutput(file.created_at, 'created_at')}</span>
                                    <span class='swlri-file-manager-browse-footer-item'><span class='swlri-file-manager-browse-footer-icon'>${icons.languageIcon}</span>${this._formatColOutput(file.language, 'language')}</span>
                                </div>
                            </div>
                        </div>
                        <div class='swlri-file-manager-browse-info-all-info-container${this._toggledFiles[ind] ? ' swlri-file-manager-browse-info-expanded' : ''}'>
                            <div class='swlri-file-manager-browse-ext-container'>
                            </div>
                            <div class='swlri-file-manager-browse-info-all-info'>
                                ${fileManagerBrowse._header.map((h)=>{
                                    return html`
                                        <div class="swlri-file-manager-browse-info-single-info">
                                         <span class="swlri-file-manager-browse-info-single-info-title">${h.title}</span>
                                         <span class="swlri-file-manager-browse-info-single-info-value">${this._formatColOutput(file[h.alias], h.alias, false, true)}</span>
                                        </div>
                                    `
                                })}
                            </div>
                        </div>
                    `
                })}
            </div>
            <div class='swlri-file-manager-browse-results-pagination'>
            ${this._fileList.length ? html`
                <span class='swlri-file-manager-browse-results-pagination-pages'><span class="swlri-file-manager-browse-pagination-icon" page='prev' @click=${this._changePage}>${icons.chevLeft}</span><span class="swlri-file-manager-browse-pagination-text">${this._getFooterNavigation()}</span><span page='next' class="swlri-file-manager-browse-pagination-icon" @click=${this._changePage}>${icons.chevRight}</span></span>
            ` : ''}
        </div>
        `;
    }

    _changePage(e){
        let page = e.currentTarget?.getAttribute("page");
        if(page != 'next' && page != 'prev') return;

        let forward = page == 'next';
        let newPage = fileManagerBrowse.currentPage;
        if(forward && fileManagerBrowse.currentPage + 1 <=  this._totalPageNumber){
            newPage = fileManagerBrowse.currentPage + 1;
        }
        else if (!forward && fileManagerBrowse.currentPage - 1 > 0){
            newPage = fileManagerBrowse.currentPage - 1
        } else return;

        fileManagerBrowse.currentPage = newPage;

    }
    _getFooterNavigation(){
        return 'Page '+fileManagerBrowse.currentPage + ' of ' +  this._totalPageNumber;
    }

    _updateFileList(){
        const limit = 10;
        let toggledFiles = {};
        fileManagerBrowse._fileList.forEach((v,i)=>{
            toggledFiles[i] = false;
        })
        this._totalPageNumber = Math.ceil(fileManagerBrowse._currentTotalFiles/limit);
        this._toggledFiles = {...toggledFiles};
        this._fileList = [...fileManagerBrowse._fileList];
    }
}